export default {"src":"/_next/static/media/Search.0a11020d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};